import React, { useState } from "react";
import cx from "classnames";
import { Input } from "reactstrap";
import DropDown from "../DropDown/DropDown";
import { getSearchOptions } from "../../services/getSearchOptions";
import {
  getSelected,
  getButtonText,
  handleHotSpotFormFieldChange
} from "../../services/filters";
import { formSpotNamesConvertor } from "../../services/formNamesConvertor";
import { ModalConsumer } from "../../common/ModalContext";
import Button from "../../components/Button/Button";
import ModalWithDropDown from "../../components/ModalWithDropDown/ModalWithDropDown";
import { FIELDS_HOTSPOTS } from "../../constants/hotSpots.js";
import COUNTRIES from "../../constants/countries";
import { addNew } from "../../services/textsForm";
import styles from "../SpotForm/SpotForm.module.scss";
import hotSpotStyles from "../HotSpotForm/HotSpotForm.module.scss";

const FirstStep = ({ state }) => {
  const [fieldActive, setFieldActive] = useState("problems");
  const {
    countries, setCountries,
    hotSpotFields, setHotSpotFields,
    name, setName,
    address, setAddress,
    problem, setProblem,
    solutions, setSolutions,
    addFieldObject,
    validationError, setValidationError, changeValidationError, changeMultipleFieldsObject,type
  } = state
  const firstProblems = problem?.length?[...problem]:[]
  const lastProblem = firstProblems.pop();
  const firstSolutions = solutions?.length?[...solutions]:[]
  const lastSolutions = firstSolutions.pop()
  const cancelValidationError = (filterType) => {
    // MOVE TO SERVICES?
    setValidationError(
      validationError.filter((errorItem) => errorItem !== filterType)
    );
  };
  const getChangeFilterFunction = (modalId, value) => {
    ///MOVE TO SERVICES
    // eslint-disable-next-line default-case
    switch (modalId) {
      case "countries":
        setCountries(value);
        break;
      case "hotSpotFields":
        setHotSpotFields(value);
        break;
    }
  };
  

  return (
    <div>
      <p className={hotSpotStyles.title}>General</p>
      <div className={hotSpotStyles.inlineForm}>
        <div className={hotSpotStyles.formItem}>
          <p className={hotSpotStyles.fieldLabel}>name hot spot*</p>
          <p className={hotSpotStyles.fieldLabelText}>{addNew.titleText}</p>
          <Input
            name="name"
            placeholder={'Hot Spot'}
            value={name}
            onChange={(event) => {
              setName(event.target.value);
              setValidationError(
                validationError.filter((errorItem) => errorItem !== "name")
              )
            }}
            className={cx(hotSpotStyles.input, {
              [hotSpotStyles.inputError]: validationError.includes("name"),
            })}
          />
        </div>
        <div className={cx(hotSpotStyles.formItem, hotSpotStyles.inlineSpace, hotSpotStyles.dropDown)}>
          <p className={hotSpotStyles.fieldLabel}>Fields*</p>
          <p className={hotSpotStyles.fieldLabelText}>{addNew.fieldTitleText}</p>
          <DropDown
            name={"hotSpotFields"}
            className={styles.autocomplete}
            changeValidationError={changeValidationError}
            onChange={handleHotSpotFormFieldChange.bind({
              filter: "hotSpotFields",
              changeFilter:setHotSpotFields,
              selected: hotSpotFields,
              cancelValidationError: cancelValidationError,
            })}
            selected={hotSpotFields}
            onClear={() => setHotSpotFields([])}
            dropDownErrorClass={
              validationError.includes("hotSpotFields") &&
              styles.dropDownError
            }
            options={FIELDS_HOTSPOTS.filter((option) => option.value !== "all")}
            buttonText={getButtonText(
              hotSpotFields,
              formSpotNamesConvertor("hotSpotFields"),
              "hotSpotFields"
            )}
          />
        </div>
      </div>

      <div>

        <div className={cx(styles.dropDownMobile, hotSpotStyles.spaceBlock)}>
          <ModalConsumer>
            {({ toggleModal }) => (
              <>
                <p
                  className={cx(styles.fieldLabel, {
                    [styles.labelError]:
                      validationError.includes("hotSpotFields"),
                  })}
                >
                  Fields*
                </p>
                <Button
                  onClick={() => {
                    toggleModal("hotSpotFields");
                  }}
                  className={cx(
                    styles.filterButton,
                    {
                      [styles.dropDownError]:
                        validationError.includes("hotSpotFields"),
                    },
                    hotSpotFields.length
                      ? styles.labelValue
                      : styles.labelName
                  )}
                >
                  {getButtonText(
                    hotSpotFields,
                    formSpotNamesConvertor("hotSpotFields"),
                    "fieldsHotSpots"
                  )}
                </Button>
              </>
            )}
          </ModalConsumer>
        </div>
        <div className={cx(styles.dropDownMobile, hotSpotStyles.spaceBlock)}>
          <ModalConsumer>
            {({ toggleModal }) => (
              <>
                <p
                  className={cx(styles.fieldLabel, {
                    [styles.labelError]:
                      validationError.includes("countries"),
                  })}
                >
                  Countries*
                </p>
                <Button
                  onClick={() => {
                    toggleModal("countries");
                  }}
                  className={cx(
                    styles.filterButton,
                    {
                      [styles.dropDownError]:
                        validationError.includes("countries"),
                    },
                    countries?.length ? styles.labelValue : styles.labelName
                  )}
                >
                  {getButtonText(
                    countries,
                    formSpotNamesConvertor("countries"),
                    "countries"
                  )}
                </Button>
              </>
            )}
          </ModalConsumer>
        </div>
        <div className={cx(hotSpotStyles.inlineForm)}>
          <div className={cx(hotSpotStyles.dropDownDesktop, hotSpotStyles.dropDownCountries)}>
            <p className={hotSpotStyles.fieldLabel}>Countries*</p>
            <p className={hotSpotStyles.fieldLabelText}>{addNew.locationTitleText}</p>
            <DropDown
              name="countries"
              className={cx(styles.autocomplete)}
              changeValidationError={changeValidationError}
              onChange={handleHotSpotFormFieldChange.bind({
                filter: "countries",
                changeFilter: setCountries,
                selected: countries,
                cancelValidationError: cancelValidationError,
              })}
              selected={countries}
              onClear={() => setCountries([])}
              dropDownErrorClass={
                validationError.indexOf("countries") !== -1 &&
                styles.dropDownError
              }
              options={COUNTRIES.filter((option) => option.value !== "all")}
              buttonText={getButtonText(
                countries,
                formSpotNamesConvertor("countries"),
                "countries"
              )}
            />
          </div>
          {/* ADDRESS */}
          <div className={cx(hotSpotStyles.inlineSpace, hotSpotStyles.formItem)}>
            <p className={hotSpotStyles.fieldLabel}>address*</p>
            <p className={hotSpotStyles.fieldLabelText}>{addNew.addressTitleText}</p>
            <Input
              name="address"
              placeholder="Address"
              value={address}
              onChange={(event) => {
                setAddress(event.target.value);
                setValidationError(
                  validationError.filter((errorItem) => errorItem !== "address")
                )
              }}
              className={cx(hotSpotStyles.input, {
                [hotSpotStyles.inputError]: validationError.includes("address"),
              })}
            />
          </div>
        </div>
        <div className={hotSpotStyles.firstStepButtonsContainer}>
          <Button className={cx(hotSpotStyles.fieldsToggle, { [hotSpotStyles.fieldsToggleActive]: fieldActive === "problems" })} onClick={() => setFieldActive("problems")}>Problems</Button>
          <Button className={cx(hotSpotStyles.fieldsToggle, { [hotSpotStyles.fieldsToggleActive]: fieldActive === "solutions" })} onClick={() => setFieldActive("solutions")}>Solutions</Button>
        </div>
        {/* Problem */}
        
        {fieldActive === "problems" && <div className={styles.multipalFields}>
          {firstProblems?.map((problemItem, index) => (
            <div className={hotSpotStyles.fieldsBox} key={index}>
              <div className={hotSpotStyles.linkFormsText}>
                <div className={hotSpotStyles.formItem}>
                  <p className={hotSpotStyles.fieldLabel}>problem title</p>
                  <p className={hotSpotStyles.fieldLabelText}>{addNew.problemTitleText}</p>
                  <Input
                    name="problemTitle"
                    placeholder="Problem Title"
                    value={problemItem?.title}
                    onChange={(e) => {
                      changeMultipleFieldsObject(
                        e.target.name,
                        e.target.value,
                        index,
                        setProblem,
                        problem
                      );
                      setValidationError(
                        validationError.filter((errorItem) => errorItem !== "problem")
                      )
                    }}
                    className={cx(hotSpotStyles.input, {
                      [hotSpotStyles.inputError]: validationError.includes("problem"),
                    })}
                  />
                </div>
                <div className={styles.textareaContainer}>
                  <p className={hotSpotStyles.fieldLabel}>description problem</p>
                  <p className={cx(hotSpotStyles.fieldLabelTextTextarea, hotSpotStyles.fieldLabelText)}>{addNew.problemDescriptionText}</p>
                  <Input
                    className={cx(styles.textarea, {
                      [hotSpotStyles.inputError]: validationError.includes("problem"),
                    })}
                    type="textarea"
                    name="problemText"
                    placeholder="Problem Text"
                    onChange={(e) => {
                      changeMultipleFieldsObject(
                        e.target.name,
                        e.target.value,
                        index,
                        setProblem,
                        problem
                      );
                      setValidationError(
                        validationError.filter(
                          (errorItem) => errorItem !== "problem"
                        )
                      );
                    }}
                    value={problemItem?.text}
                  />
                  <p
                    className={cx(styles.errorLabel, {
                      "d-block": validationError.includes("problem"),
                    })}
                  >
                    {("error", "Please, add problem")}
                  </p>
                </div>
              </div>
            </div>
          ))}

          <div className={cx(hotSpotStyles.multipalFieldsContainer)}>
            <div className={hotSpotStyles.fieldsBox}>
              <div className={hotSpotStyles.linkFormsText}>
                <div className={hotSpotStyles.formItem}>
                  <p className={hotSpotStyles.fieldLabel}>problem title</p>
                  <p className={hotSpotStyles.fieldLabelText}>{addNew.problemTitleText}</p>
                  <Input
                    name="problemTitle"
                    placeholder="Problem Title"
                    value={lastProblem?.title ?? ""}
                    onChange={(e) => {
                      changeMultipleFieldsObject(
                        e.target.name,
                        e.target.value,
                        problem.length - 1,
                        setProblem,
                        problem
                      );
                      setValidationError(
                        validationError.filter((errorItem) => errorItem !== "problem")
                      )
                    }}
                    className={cx(hotSpotStyles.input, {
                      [hotSpotStyles.inputError]: validationError.includes("problem"),
                    })}
                  />
                </div>
                <div className={styles.textareaContainer}>
                  <p className={hotSpotStyles.fieldLabel}>description problem</p>
                  <p className={cx(hotSpotStyles.fieldLabelTextTextarea, hotSpotStyles.fieldLabelText)}>{addNew.problemDescriptionText}</p>
                  <Input
                    className={cx(styles.textarea, {
                      [hotSpotStyles.inputError]: validationError.includes("problem"),
                    })}
                    type="textarea"
                    name="problemText"
                    placeholder="Problem Text"
                    onChange={(e) => {
                      changeMultipleFieldsObject(
                        e.target.name,
                        e.target.value,
                        problem.length - 1,
                        setProblem,
                        problem
                      );
                      setValidationError(
                        validationError.filter(
                          (errorItem) => errorItem !== "problem"
                        )
                      );
                    }}
                    value={lastProblem?.text ?? ""}
                  />
                  <p
                    className={cx(styles.errorLabel, {
                      "d-block": validationError.includes("problem"),
                    })}
                  >
                    {("error", "Please, add problem")}
                  </p>
                </div>
              </div>

            </div>
            <Button
              className={hotSpotStyles.plusButton}
              onClick={() => addFieldObject(setProblem, problem)}
              disabled={!!lastProblem && !Object.keys(lastProblem).length}
            >
              +
            </Button>
          </div>
        </div>}
        {/* Solutions */}
        {fieldActive === "solutions" && <div className={hotSpotStyles.multiFields}>
          {firstSolutions?.map((solutionItem, index) => (
            <div className={hotSpotStyles.fieldsBox} key={index}>
              <div className={hotSpotStyles.linkFormsText}>
                <div className={hotSpotStyles.formItem}>
                  <p className={hotSpotStyles.fieldLabel}>solution name</p>
                  <p className={hotSpotStyles.fieldLabelText}>{addNew.solutionTitleText}</p>
                  <Input
                    name="solutionName"
                    placeholder="Solution Name"
                    value={solutionItem.name}
                    onChange={(e) => {
                      changeMultipleFieldsObject(
                        e.target.name,
                        e.target.value,
                        index,
                        setSolutions,
                        solutions
                      );
                      setValidationError(
                        validationError.filter((errorItem) => errorItem !== "solutions")
                      )
                    }}
                    className={cx(hotSpotStyles.input, {
                      [hotSpotStyles.inputError]: validationError.includes("solutions"),
                    })}
                  />
                </div>
                <div className={hotSpotStyles.formItem}>
                  <p className={hotSpotStyles.fieldLabel}>solution author</p>
                  <Input
                    name="solutionAuthor"
                    placeholder="Solution Author"
                    value={solutionItem.author}
                    onChange={(e) => {
                      changeMultipleFieldsObject(
                        e.target.name,
                        e.target.value,
                        index,
                        setSolutions,
                        solutions
                      );
                      setValidationError(
                        validationError.filter((errorItem) => errorItem !== "solutions")
                      )
                    }}
                    className={cx(hotSpotStyles.input, {
                      [hotSpotStyles.inputError]: validationError.includes("solutions"),
                    })}
                  />
                </div>
                <div className={hotSpotStyles.formItem}>
                  <p className={hotSpotStyles.fieldLabel}>solution link</p>
                  <Input
                    name="solutionLink"
                    placeholder="Solution Link"
                    value={solutionItem?.link ?? ""}
                    onChange={(e) => {
                      changeMultipleFieldsObject(
                        e.target.name,
                        e.target.value,
                        index,
                        setSolutions,
                        solutions
                      );
                      setValidationError(
                        validationError.filter((errorItem) => errorItem !== "solutions")
                      )
                    }}
                    className={cx(hotSpotStyles.input, {
                      [hotSpotStyles.inputError]: validationError.includes("solutions"),
                    })}
                  />
                </div>
                <div className={styles.textareaContainer}>
                  <p className={hotSpotStyles.fieldLabel}>solution text</p>
                  <p className={cx(hotSpotStyles.fieldLabelTextTextarea, hotSpotStyles.fieldLabelText)}>{addNew.solutionDescriptionText}</p>
                  <Input
                    className={cx(styles.textarea, {
                      [hotSpotStyles.inputError]: validationError.includes("solutions"),
                    })}
                    type="textarea"
                    name="solutionText"
                    placeholder="Solution Text"
                    onChange={(e) => {
                      changeMultipleFieldsObject(
                        e.target.name,
                        e.target.value,
                        index,
                        setSolutions,
                        solutions
                      );
                      setValidationError(
                        validationError.filter(
                          (errorItem) => errorItem !== "solutions"
                        )
                      );
                    }}
                    value={solutionItem.text}
                  />
                  <p
                    className={cx(styles.errorLabel, {
                      "d-block": validationError.includes("solutions"),
                    })}
                  >
                    {("error", "Please, add solutions")}
                  </p>
                </div>
              </div>
            </div>
          ))}

          <div className={cx(hotSpotStyles.multipalFieldsContainer)}>
            <div className={hotSpotStyles.fieldsBox}>
              <div className={hotSpotStyles.linkFormsText}>
                <div className={hotSpotStyles.formItem}>
                  <p className={hotSpotStyles.fieldLabel}>solution name</p>
                  <p className={hotSpotStyles.fieldLabelText}>{addNew.solutionTitleText}</p>
                  <Input
                    name="solutionName"
                    placeholder="Solution Name"
                    value={lastSolutions?.name ?? ""}
                    onChange={(e) => {
                      changeMultipleFieldsObject(
                        e.target.name,
                        e.target.value,
                        solutions.length - 1,
                        setSolutions,
                        solutions
                      );
                      setValidationError(
                        validationError.filter((errorItem) => errorItem !== "solutions")
                      )
                    }}
                    className={cx(hotSpotStyles.input, {
                      [hotSpotStyles.inputError]: validationError.includes("solutions"),
                    })}
                  />
                </div>
                <div className={hotSpotStyles.formItem}>
                  <p className={hotSpotStyles.fieldLabel}>solution author</p>
                  <Input
                    name="solutionAuthor"
                    placeholder="Solution Author"
                    value={lastSolutions?.author ?? ""}
                    onChange={(e) => {
                      changeMultipleFieldsObject(
                        e.target.name,
                        e.target.value,
                        solutions.length - 1,
                        setSolutions,
                        solutions
                      );
                      setValidationError(
                        validationError.filter((errorItem) => errorItem !== "solutions")
                      )
                    }}
                    className={cx(hotSpotStyles.input, {
                      [hotSpotStyles.inputError]: validationError.includes("solutions"),
                    })}
                  />
                </div>
                <div className={hotSpotStyles.formItem}>
                  <p className={hotSpotStyles.fieldLabel}>solution link</p>
                  <Input
                    name="solutionLink"
                    placeholder="Solution Link"
                    value={lastSolutions?.link ?? ""}
                    onChange={(e) => {
                      changeMultipleFieldsObject(
                        e.target.name,
                        e.target.value,
                        solutions.length - 1,
                        setSolutions,
                        solutions
                      );
                      setValidationError(
                        validationError.filter((errorItem) => errorItem !== "solutions")
                      )
                    }}
                    className={cx(hotSpotStyles.input, {
                      [hotSpotStyles.inputError]: validationError.includes("solutions"),
                    })}
                  />
                </div>
                <div className={styles.textareaContainer}>
                  <p className={hotSpotStyles.fieldLabel}>solution text</p>
                  <p className={cx(hotSpotStyles.fieldLabelTextTextarea, hotSpotStyles.fieldLabelText)}>{addNew.solutionDescriptionText}</p>
                  <Input
                    className={cx(styles.textarea, {
                      [hotSpotStyles.inputError]: validationError.includes("solutions"),
                    })}
                    type="textarea"
                    name="solutionText"
                    placeholder="Solution Text"
                    onChange={(e) => {
                      changeMultipleFieldsObject(
                        e.target.name,
                        e.target.value,
                        solutions.length - 1,
                        setSolutions,
                        solutions
                      );
                      setValidationError(
                        validationError.filter(
                          (errorItem) => errorItem !== "solutions"
                        )
                      );
                    }}
                    value={lastSolutions?.text ?? ""}
                  />
                  <p
                    className={cx(styles.errorLabel, {
                      "d-block": validationError.includes("solutions"),
                    })}
                  >
                    {("error", "Please, add solutions")}
                  </p>
                </div>
              </div>
            </div>
            <Button
              className={hotSpotStyles.plusButton}
              onClick={() => addFieldObject(setSolutions, solutions)}
              disabled={!!lastSolutions && !Object.keys(lastSolutions).length}
            >
              +
            </Button>
          </div>
        </div>}
      </div>

      <ModalConsumer>
        {({ isOpen, toggleModal, modalId }) => {
          return (
            (modalId === "countries" || // TO REFACTOR ONE OF
              modalId === "hotSpotFields" ||
              modalId === "businessFields" ||
              modalId === "category") && (
              <ModalWithDropDown
                onSave={toggleModal}
                toggleModal={toggleModal}
                isOpen={isOpen}
                name={modalId}
                options={modalId === "hotSpotFields" ?FIELDS_HOTSPOTS.filter(option => option.value !== "all"): getSearchOptions(modalId).filter(
                  (option) => option.value !== "all"
                )}
                selected={getSelected({
                  modalId,
                  countries,
                  hotSpotFields,
                })}
                onChange={handleHotSpotFormFieldChange.bind({
                  filter: modalId,
                  changeFilter: (value) =>
                    getChangeFilterFunction(modalId, value),
                  selected: getSelected({
                    modalId,
                    countries,
                    hotSpotFields,
                  }),
                  cancelValidationError: cancelValidationError,
                })}
                onClear={() => getChangeFilterFunction(modalId, [])}
                changeValidationError={changeValidationError}
              />
            )
          );
        }}
      </ModalConsumer>
    </div>
  )
}

export default FirstStep